export default __webpack_public_path__ + "static/douglas-crockford-f79096350457743d2564eaf4b373429b.jpg";